import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({
  eyebrow = "Get Started",
  title = "Ready to see if you could save?",
  description = "Request a free savings analysis and see which processing or POS option makes the most sense for your business.",
}) {
  return (
    <section className="bg-[var(--swipe-navy)] text-white">
      <div className="container-swipe section">
        <div className="grid lg:grid-cols-[1.4fr,1fr] gap-10 items-end">
          <div>
            <div className="overline mb-4" style={{ color: "#7DB6FF" }}>{eyebrow}</div>
            <h2 className="font-display-tight text-[2rem] sm:text-[2.5rem] lg:text-[3.25rem] font-bold leading-[1.08] text-white">
              {title}
            </h2>
            <p className="mt-6 text-[17px] text-white/70 max-w-2xl leading-relaxed">{description}</p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3 lg:justify-end">
            <Link to="/savings-analysis" className="btn-primary-swipe" data-testid="cta-section-savings">
              Get Free Savings Analysis <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/contact" className="btn-outline-light" data-testid="cta-section-contact">
              Contact Swipetronics
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
